import type { Levelbucket } from 'lumen/models';
import type { LevelBucketBounds } from 'lumen/models/levelbucket';

export default function convertIndexToMarketInsightDemandLevel(
  value: number,
  levelBucket: Levelbucket | null,
): string | number {
  // The bucket boundaries are different depending on what we need to show. This info is stored in the levelBucket argument
  if (!levelBucket?.levels || !Number.isFinite(value)) {
    return '';
  }

  let marketInsightColorScaleLevel = null;

  // The levels property contains an array of level objects.
  // We use a regular for instead of a forEach so that we can make use of break;
  // As soon as the value is between the lower & upper bound we can stop looping
  for (let i = 0; i < levelBucket.levels.length; i++) {
    const levelDescription = levelBucket.levels[i] as LevelBucketBounds;
    const isLowestLevel = levelDescription.level === 1;
    const isHighestLevel = levelDescription.level === levelBucket.levels.length;

    // ToDo: this check will be deprecated once the lowest and highest level will have both a lower and upper bound
    // The lowest & highest level buckets only have 1 bound
    if (!levelDescription.upper_bound || !levelDescription.lower_bound) {
      if (
        !levelDescription.lower_bound &&
        value <= levelDescription.upper_bound
      ) {
        marketInsightColorScaleLevel = levelDescription.level;
        break;
      }

      if (
        !levelDescription.upper_bound &&
        value > levelDescription.lower_bound
      ) {
        marketInsightColorScaleLevel = levelDescription.level;
        break;
      }
    }

    // Don't check the lower_bound of lowest level
    if (isLowestLevel && value <= levelDescription.upper_bound) {
      marketInsightColorScaleLevel = levelDescription.level;
      break;
    }

    // Don't check the upper_bound of highest level
    if (isHighestLevel && value > levelDescription.lower_bound) {
      marketInsightColorScaleLevel = levelDescription.level;
      break;
    }

    if (levelDescription.upper_bound && levelDescription.lower_bound) {
      if (
        value > levelDescription.lower_bound &&
        value <= levelDescription.upper_bound
      ) {
        marketInsightColorScaleLevel = levelDescription.level;
        break;
      }
    }
  }

  return marketInsightColorScaleLevel === null
    ? ''
    : marketInsightColorScaleLevel;
}
